import { useTheme } from 'styled-components';
import { getProgramGrantStatusDisplayValue, ClientProgramStatus, normalizeClientProgramStatus, ProgramGrantStatus, } from '../entities/programs-entities';
import RfpStatus from '../enums/rfp-status';
const getProgramStatusColorFromTheme = (status, theme) => {
    const colors = {
        Completed: theme.colors.green_1,
        Active: theme.colors.white_1,
        Rejected: theme.colors.red_1,
        Canceled: theme.colors.red_1,
    };
    return colors[status];
};
export const useProgramStatusColor = (status) => {
    const theme = useTheme();
    return getProgramStatusColorFromTheme(status, theme);
};
export const getProgramStatusColor = useProgramStatusColor;
export const getRfpStatusColor = (status, theme) => {
    switch (status) {
        case RfpStatus.PendingApproval:
            return theme.colors.yellow_4;
        case RfpStatus.Active:
            return theme.colors.orange_4;
        case RfpStatus.FilterCandidates:
            return theme.colors.blue_4;
        case RfpStatus.EvaluateFinalists:
            return theme.colors.purple_4;
        case RfpStatus.Completed:
            return theme.colors.green_4;
        case RfpStatus.Canceled:
            return theme.colors.grey_5;
        case RfpStatus.Rejected:
            return theme.colors.red_5;
        default:
            return '';
    }
};
export const getProgramGrantStatusColor = (status, theme) => {
    switch (getProgramGrantStatusDisplayValue(status)) {
        case ProgramGrantStatus.Review:
            return theme.colors.yellow_4;
        case ProgramGrantStatus.Identified:
            return theme.colors.orange_4;
        case ProgramGrantStatus.Qualify:
        case ProgramGrantStatus.Handoff:
        case ProgramGrantStatus.KickoffWriting:
            return theme.colors.blue_4;
        case ProgramGrantStatus.Submitted:
            return theme.colors.purple_4;
        case ProgramGrantStatus.Accepted:
            return theme.colors.green_4;
        case ProgramGrantStatus.Refused:
            return theme.colors.grey_5;
        case ProgramGrantStatus.ClosedLost:
            return theme.colors.red_5;
        default:
            return '';
    }
};
export const getClientProgramStatusColor = (status, theme) => {
    switch (normalizeClientProgramStatus(status)) {
        case ClientProgramStatus.ProjectValidationAndEligibility:
            return theme.colors.orange_4;
        case ClientProgramStatus.GatherInformation:
            return theme.colors.blue_4;
        case ClientProgramStatus.DraftFirstVersion:
            return theme.colors.purple_4;
        case ClientProgramStatus.PreSendReview:
            return theme.colors.green_4;
        case ClientProgramStatus.SubmitApplication:
            return theme.colors.grey_5;
        case ClientProgramStatus.DecisionsMade:
            return theme.colors.yellow_4;
        case ClientProgramStatus.Trash:
            return theme.colors.red_5;
        default:
            return '';
    }
};
